"use strict";

var _classCallCheck = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Alignment_1 = require("./Alignment");
var Utils_1 = require("./Utils");
/**
 * FastaAlignment
 * This class represents a Fasta formatted multiple sequence alignment.
 */
var FastaAlignment = /*#__PURE__*/function (_Alignment_1$Alignmen) {
  _inherits(FastaAlignment, _Alignment_1$Alignmen);
  function FastaAlignment() {
    _classCallCheck(this, FastaAlignment);
    return _possibleConstructorReturn(this, _getPrototypeOf(FastaAlignment).apply(this, arguments));
  }
  _createClass(FastaAlignment, null, [{
    key: "fromFileContents",
    /**
     * Parse a string that contains a fasta alignment.
     * @param fileName
     * @param fileContents
     */
    value: function fromFileContents(fileName, fileContents) {
      var trimmedFile = fileContents.trim();
      if (trimmedFile.length < 1 || trimmedFile[0] !== ">") {
        throw Utils_1.getParseError("Fasta", "File needs to begin with '>'");
      }
      var fastaSplitCaret = trimmedFile.split(">");
      var sequences = [];
      for (var i = 0; i < fastaSplitCaret.length; i++) {
        var seqArr = fastaSplitCaret[i].split(/\r?\n/);
        if (seqArr.length > 1) {
          var seqObj = {
            id: seqArr[0],
            sequence: seqArr.slice(1).join("")
          };
          sequences.push(seqObj);
        }
      }
      return new FastaAlignment(fileName, sequences);
    }
  }]);
  return FastaAlignment;
}(Alignment_1.Alignment);
exports.FastaAlignment = FastaAlignment;